// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__MhDO_","container":"styles_container__2y087","header":"styles_header__jgCBj","homeLink":"styles_homeLink__bCEhC","inlineLink":"styles_inlineLink__BZhhy"};